import React, { useReducer, createContext, useContext } from "react";
import { GlobalConstants } from "./constants/GlobalConstants";

const getClearedApiCache = (cacheCopy, suffixesToClear) => {
  suffixesToClear.map(suf => {
    if (cacheCopy[suf]) {
      cacheCopy[suf] = null;
    }
  });

  return cacheCopy;
};

export const Reducer = (state: any, { type, payload }: any) => {
  switch (type) {
    case GlobalConstants.BCStoreReducerCases.SET_API_CACHE:
      return {
        ...state,
        apiCache: {
          ...state.apiCache,
          [payload.apiSuffix]: payload?.data
        }
      };
    case GlobalConstants.BCStoreReducerCases.SET_API_MULTI_CACHE:
      return {
        ...state,
        apiCache: {
          ...state.apiCache,
          ...payload
        }
      };
    case GlobalConstants.BCStoreReducerCases.CLEAR_API_CACHE:
      return {
        ...state,
        apiCache: getClearedApiCache({ ...state.apiCache }, payload.apiSuffixes)
      };
    case GlobalConstants.BCStoreReducerCases.SET_API_CACHE_GRID_COUNT:
      return {
        ...state,
        apiCacheGridCounts: {
          ...state.apiCacheGridCounts,
          [payload.apiSuffix]: payload?.totalGridCount
        }
      };
    default:
      return state;
  }
};

const initialState: any = {
  apiCache: {},
  apiCacheGridCounts: {}
};

const BCGlobalCacheStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);
export const useBCGlobalCacheReducer = () => useContext(Context);
export default BCGlobalCacheStore;